<template>
    <div v-if="!success">
        <h1><div class="icon__lead"></div>Заполните форму</h1>
        <div class="w-modal__form">
            <form @submit.prevent="submit">
                <div class="form-control__wrap" :class="{'is-invalid': errors.name}">
                    <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
                    <input type="text" class="form-control" v-model="form.name" placeholder="Имя и фамилия">
                    <div class="invalid-sup">*</div>
                </div>
                <div class="form-control__wrap" :class="{'is-invalid': errors.email}">
                    <div class="invalid-feedback" v-if="errors.email">{{ errors.email[0] }}</div>
                    <input type="text" class="form-control" v-model="form.email" placeholder="E-mail">
                    <div class="invalid-sup">*</div>
                </div>
                <div class="form-control__wrap" :class="{'is-invalid': errors.phone}">
                    <div class="invalid-feedback" v-if="errors.phone">{{ errors.phone[0] }}</div>
                    <input type="text" class="form-control mask-phone" v-model="form.phone" placeholder="Контактный телефон">
                    <div class="invalid-sup">*</div>
                </div>
                <div class="form-control__wrap form-control__wrap-date"  :class="{'is-invalid': errors.date}">
                    <div class="invalid-feedback" v-if="errors.date">{{ errors.date[0] }}</div>
                    <input ref="date" id="lead-input-date" type="text" class="form-control" v-model="form.date" placeholder="Дата">
                    <div class="invalid-sup">*</div>
                </div>
                <!-- <div class="form-control__wrap form-control__wrap-time">
                    <input type="text" class="form-control mask-time" placeholder="Время">
                </div> -->
                <div class="form-control__wrap" :class="{'is-invalid': errors.promocode}">
                    <div class="invalid-feedback" v-if="errors.promocode">{{ errors.promocode[0] }}</div>
                    <input type="text" class="form-control" v-model="form.promocode" placeholder="Промокод (при наличии)">
                </div>
                <div class="form-control__wrap" :class="{'is-invalid': errors.comment}">
                    <div class="invalid-feedback" v-if="errors.comment">{{ errors.comment[0] }}</div>
                    <textarea class="form-control" v-model="form.comment" placeholder="Комментарий"></textarea>
                </div>

                <div class="form-control__wrap form-button__wrap">
                    <button class="button" type="submit">Оставить заявку</button>
                </div>
            </form>
        </div>
        <div class="w-modal__terms">
            Нажимая на кнопку «Оставить заявку», вы соглашаетесь
            <br>
            с <a href="/terms.pdf">Пользовательским соглашением</a>
        </div>
    </div>
    <div v-else>
        <div class="icon__lead-send"></div>
        <h1 class="h1-lead-send">
            Спасибо! Ваша заявка отправлена!
        </h1>
        <p>В ближайшее время с вами свяжется представитель компании</p>
    </div>
</template>

<script>
import useEvents from "../composables/events";
import {onMounted, ref} from "vue";
import AirDatepicker from "air-datepicker";
import 'air-datepicker/air-datepicker.css'

export default {
    name: "EventLeadForm",
    props: {
        id: {
            required: true,
            type: Number
        }
    },
    setup(props) {
        onMounted(function () {
            new AirDatepicker('#lead-input-date', {
                days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
                daysShort: ['Вос','Пон','Вто','Сре','Чет','Пят','Суб'],
                daysMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
                months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
                today: 'Сегодня',
                clear: 'Очистить',
                dateFormat: 'dd.MM.yyyy',
                timepicker: true,
                timeFormat: 'HH:mm',
                firstDay: 1
            });
        })

        const { errors, sendLeadForm } = useEvents()
        const success = ref(false)
        const date = ref(null);

        const form = ref({
            id: props.id,
            name: '',
            email: '',
            phone: '',
            date: '',
            promocode: '',
            comment: ''
        })

        const submit = async () => {
            form.value.date = date.value.value;

            success.value = await sendLeadForm(form.value)
        }

        return {
            form,
            errors,
            success,
            date,
            submit
        }
    }
}
</script>

<style scoped>

</style>
